import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'

function MyImage({ src, className, isLoadOnInteraction, errorSrc, disableAutoHeight, ...rest }) {
  const [url, setUrl] = useState(isLoadOnInteraction ? noImage : src)
  const { isLoaded } = useOnMouseAndScroll()
  // delete rest.layout
  useEffect(() => {
    if (isLoadOnInteraction) {
      if (isLoaded) setUrl(src)
      else setUrl(noImage)
    } else {
      setUrl(src)
    }
  }, [src, isLoaded])

  return (
    <Image
      src={url}
      className={`d-block w-100 ${!disableAutoHeight ? 'h-auto' : ''} ${className}`}
      onError={(e) => setUrl(errorSrc || noImage)}
      {...rest}
    />
  )
}
MyImage.propTypes = {
  src: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  disableAutoHeight: PropTypes.bool,
  isLoadOnInteraction: PropTypes.bool,
  errorSrc: PropTypes.object,
  className: PropTypes.string
}
export default React.memo(MyImage)
